import { render, staticRenderFns } from "./vehicleView.vue?vue&type=template&id=9027367a"
import script from "./vehicleView.vue?vue&type=script&lang=js"
export * from "./vehicleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports